import { Controller } from "@hotwired/stimulus"

// FD-297 (perf): build heavy content (e.g. a Tiptap reply editor) only when its
// <details> is first opened, instead of once per comment up front. The content lives
// in an inert <template>; on first open we clone it into the slot, which lets Stimulus
// connect the controllers inside it (block-editor → Tiptap) at that moment.
//
//   <details data-controller="lazy-reveal" data-action="toggle->lazy-reveal#reveal">
//     <summary>…</summary>
//     <template data-lazy-reveal-target="template">…heavy markup…</template>
//     <div data-lazy-reveal-target="slot"></div>
//   </details>
export default class extends Controller {
  static targets = ["template", "slot"]

  // "Have we revealed yet?" is recorded on the SLOT, not on the controller instance —
  // the same trap clone_options_controller documents (FD-603). Posting a comment is a
  // same-url redirect_back, which Turbo handles as a morph, and the server renders the
  // slot empty: idiomorph strips the cloned editor while the <details> element (so the
  // controller instance) survives. An in-memory latch would stay `true` and every later
  // open would expand an empty disclosure until a full reload. The marker attribute is
  // removed by the same morph that removes the clone, so the two can't disagree.
  reveal() {
    if (!this.element.open || this.slotTarget.dataset.lazyRevealed) return
    this.slotTarget.dataset.lazyRevealed = "true"
    this.slotTarget.append(this.templateTarget.content.cloneNode(true))
  }
}
